<template><div><h1>VUX V2.5.3 发布日志</h1>
<h2><a href="/zh-CN/components/group.html">Group</a></h2>
<ul><li>[enhance] labelAlign 支持 justify #1574</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] 修复在 x-textarea 后引入 popup-picker label 宽度被覆盖 #1696</li>
</ul>
<h2><a href="/zh-CN/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] 轮播个数不为2时清除 listTtwoLoopItem 列表 #1684 @weizs</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[feature] 新增 prop:show 并且支持.sync修饰符</li>
</ul>
<h2><a href="/zh-CN/components/x-header.html">XHeader</a></h2>
<ul><li>[feature] 添加 slot:overwrite-title #1669</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.3 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.3-250.vue?d75d6c7e